import SvgIcoNotDefault from './SvgIcoNotDefault';

export default SvgIcoNotDefault;
